import MediaObjectCarousel from "./MediaObjectCarousel"
export default MediaObjectCarousel
